module.exports = __webpack_public_path__ + "img/fox.64dc04ed.svg";